// 后台账号的密码复杂度，与服务端 operatorPasswordRule 一致（docs/04 第 9 节，决策 D201）。
import { utf8Bytes } from "./form";

/** 后台账号密码的最短字符数。 */
export const OPERATOR_PASSWORD_MIN = 12;

/** 大写字母、小写字母、数字、符号四类里至少要有的类数。 */
const CLASSES_MIN = 3;

/** 给填密码的人看的规则说明。 */
export const OPERATOR_PASSWORD_RULE = `至少 ${OPERATOR_PASSWORD_MIN} 个字符，包含大写字母、小写字母、数字、符号中的至少 ${CLASSES_MIN} 类，不能包含用户名（用户名至少 3 个字符时）`;

// 与 Go 的 unicode.IsUpper、IsLower、IsDigit 对应；符号是既不是字母也不是数字的字符（含空格），没有大小写的字母（如汉字）不算任何一类
const CLASS_PATTERNS = [/\p{Lu}/u, /\p{Ll}/u, /\p{Nd}/u, /[^\p{L}\p{Nd}]/u];

/** 用户名至少这么多字符才检查密码是否包含它：太短的用户名（如 li）会误伤大量正常密码。 */
const USERNAME_CHECK_MIN = 3;

/** 密码不满足规则时返回给人看的原因，满足时返回 undefined。用户名不到 USERNAME_CHECK_MIN 个字符时不检查是否包含用户名。 */
export function operatorPasswordError(username: string, password: string): string | undefined {
  if ([...password].length < OPERATOR_PASSWORD_MIN) return `密码至少 ${OPERATOR_PASSWORD_MIN} 个字符。`;
  if (utf8Bytes(password) > 72) return "密码不超过 72 字节。";
  if (CLASS_PATTERNS.filter((p) => p.test(password)).length < CLASSES_MIN) return `密码要包含大写字母、小写字母、数字、符号中的至少 ${CLASSES_MIN} 类。`;
  if ([...username].length >= USERNAME_CHECK_MIN && password.toLowerCase().includes(username.toLowerCase())) return "密码不能包含用户名。";
  return undefined;
}

/** 改密码表单的草稿：当前密码、新密码与确认。 */
export interface PasswordDraft { current: string; next: string; confirm: string }
/** 改密码表单各字段的错误。 */
export type PasswordDraftErrors = Partial<Record<keyof PasswordDraft, string>>;

/** 改密码表单的初值。 */
export const EMPTY_PASSWORD_DRAFT: PasswordDraft = { current: "", next: "", confirm: "" };

/** 提交前在本地先查一遍，规则与服务端一致（D201）；当前密码对不对只有服务端知道。 */
export function passwordErrors(username: string, d: PasswordDraft): PasswordDraftErrors {
  const errors: PasswordDraftErrors = {};
  if (!d.current) errors.current = "填写当前密码。";
  const next = d.next ? operatorPasswordError(username, d.next) : "填写新密码。";
  if (next) errors.next = next;
  else if (d.next === d.current) errors.next = "新密码不能与当前密码相同。";
  if (d.confirm !== d.next) errors.confirm = "两次输入的新密码不一致。";
  return errors;
}
